import React, { useState } from "react";
import resume from "../assets/resume.png";
import ComingSoon from "./ComingSoon";
import resumepdf from "../assets/SubhadipDas_Resume.pdf";
import PopUp from "./PopUp";
import resumeData from "../data/resume";

const Resume = () => {
  const [hideWrittenResume, setHideWrittenResume] = useState("");
  const [hideVideoResume, setHideVideoResume] = useState("hidden");
  const handleWrittenResume = () => {
    setHideWrittenResume("");
    setHideVideoResume("hidden");
  };
  const handleVideoResume = () => {
    setHideVideoResume("");
    setHideWrittenResume("hidden");
  };

  return (
    <div>
      <PopUp />
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Resume
        </h1>
        <div className="my-10 text-lg">
          <span className="flex justify-around text-lg sm:text-xl font-bold rounded-xl px-3 py-2 break-words space-x-5 sm:space-x-0">
            <div className="flex">
              <div className="">
                <label title="Click to see my resume">
                  <button
                    className="bg-purple-800 hover:bg-purple-700 duration-200 text-slate-100 px-3 py-2 rounded-xl"
                    onClick={handleWrittenResume}
                  >
                    Written Resume
                  </button>
                </label>
              </div>
            </div>
            <div className="flex">
              <div className="hidden sm:block font-extrabold">
                <span>|</span>
              </div>
            </div>
            <div className="flex">
              <div className="">
                <label title="Click to watch my resume">
                  <button
                    className="bg-purple-800 hover:bg-purple-700 duration-200 text-slate-100 px-3 py-2 rounded-xl"
                    onClick={handleVideoResume}
                  >
                    Video Resume
                  </button>
                </label>
              </div>
            </div>
          </span>
        </div>
        <div className="">
          <div
            className={`${hideWrittenResume} justify-center sm:bg-slate-200 sm:dark:bg-slate-800 rounded-2xl sm:p-10 sm:mx-60`}
          >
            <div>
              <a href={resumepdf} download={"SubhadipDas_Resume"}>
                <img
                  className="w-full max-w-[775px] h-auto rounded-2xl"
                  src={resume}
                  alt="Subhadip Das resume preview"
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </div>
            <div className="sm:grid grid-cols-3 sm:space-x-5 text-center mt-5 sm:mt-10">
              {resumeData.actions.map((a) => {
                const isDownload = a.type === "download";
                const href = isDownload ? resumepdf : a.href;
                const target = a.target ? { target: a.target } : {};
                const props = isDownload ? { download: "SubhadipDas_Resume" } : {};
                return (
                  <a href={href} target={target} key={a.label} {...props}>
                    <button className="w-full my-2 sm:my-0 justify-center text-center bg-purple-800 hover:bg-purple-700 duration-200 text-slate-100 px-3 py-2 rounded-lg font-semibold">
                      {a.label}
                    </button>
                  </a>
                );
              })}
            </div>
            <div className="justify-center text-center mt-5">
              <p className="text-[14px] dark:font-light text-green-600 dark:text-green-400">
                <i>{resumeData.updatedText}</i>
              </p>
            </div>
          </div>
          <div
            className={`${hideVideoResume} flex justify-center sm:bg-slate-200 sm:dark:bg-slate-800 rounded-2xl sm:p-10 sm:mx-60`}
          >
            <ComingSoon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
